export enum ActionTypes {
    PAYMENT_LIST = 'PAYMENT_LIST',
    PAYMENT_DETAIL = 'PAYMENT_DETAIL',
    PAYMENT_SOUKI_DETAIL = 'PAYMENT_SOUKI_DETAIL',
    PAYMENT_PDF_PREVIEW = 'PAYMENT_PDF_PREVIEW',
    PAYMENT_SOUKI_PDF_PREVIEW = 'PAYMENT_SOUKI_PDF_PREVIEW',
    PAYMENT_PDF_DOWNLOAD = 'PAYMENT_PDF_DOWNLOAD',
}
